import React, { useEffect, useState } from "react";
import Table from "../../utilities/Table";
import axios from "axios";
import { couponColumns } from "../../utilities/utility";
import AdminCoupon from "../components/coupons/AdminCoupon";
import { Modal, Button } from "react-bootstrap";
import Input from "../components/customs/Input";

export default function Promos() {
  const [coupons, setCoupon] = useState([]);
  const [show, setShow] = useState(false);
  const [state, setState] = useState({})

  const handleClose = () => setShow(false);
  const showModal = (state) => setShow(state);
  const getcoupons = async () => {
    const response = await axios.get("/api/coupon/");
    const coupons = await response.data;
    setCoupon(coupons);
  };
  useEffect(() => {
    getcoupons();

  }, []);

  const onChangeText = ({ target }) => {
    setState((prevState) => ({ ...prevState, [target.name]: target.value }));
  };

  const saveAdminCoupon = async () => {
    const response = await axios.post('/api/admin-coupon/', state);
    if (response.status === 200) {
      setShow(false);
      alert(response.data.msg);
    }
  }

  return (
    <div className="wrapper wrapper-content">
      <AdminCoupon showModal={showModal} />

      <div className="row-lg">
        <Table
          title="Coupons"
          data={coupons}
          columns={couponColumns}
          className="table-responsive table-sm"
        />
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Generate Coupon</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Input
            label="Promo Text"
            required={true}
            name="promo_text"
            type="text"
            handler={onChangeText}
          />
          <Input
            label="Promo Code"
            required={true}
            name="promo_code"
            type="text"
            handler={onChangeText}
          />
          <Input
            label="Discount (%)"
            required={true}
            name="discount"
            type="text"
            handler={onChangeText}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={saveAdminCoupon}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
